import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { AgendaGroup } from './AgendaGroup';
import { TIME_INPUT } from '../utils';

export default createBuilderModule(withChildren(AgendaGroup), {
  name: 'AgendaGroup',
  inputs: [TIME_INPUT, { name: 'borderBottom', type: 'boolean' }],
});
